export const emojiList = {
  '[可爱]': { file: 'emoji_01' },
  '[大笑]': { file: 'emoji_00' },
  '[色]': { file: 'emoji_02' },
  '[嘘]': { file: 'emoji_03' },
  '[亲]': { file: 'emoji_04' },
  '[呆]': { file: 'emoji_05' },
  '[口水]': { file: 'emoji_06' },
  '[汗]': { file: 'emoji_145' },
  '[呲牙]': { file: 'emoji_07' },
  '[鬼脸]': { file: 'emoji_08' },
  '[害羞]': { file: 'emoji_09' },
  '[偷笑]': { file: 'emoji_10' },
  '[调皮]': { file: 'emoji_11' },
  '[可怜]': { file: 'emoji_12' },
  '[敲]': { file: 'emoji_13' },
  '[惊讶]': { file: 'emoji_14' },
  '[流感]': { file: 'emoji_15' },
  '[委屈]': { file: 'emoji_16' },
  '[流泪]': { file: 'emoji_17' },
  '[嚎哭]': { file: 'emoji_18' },
  '[惊恐]': { file: 'emoji_19' },
  '[怒]': { file: 'emoji_20' },
  '[酷]': { file: 'emoji_21' },
  '[不说]': { file: 'emoji_22' },
  '[鄙视]': { file: 'emoji_23' },
  '[阿弥陀佛]': { file: 'emoji_24' },
  '[坏笑]': { file: 'emoji_25' },
  '[睡着]': { file: 'emoji_26' },
  '[口罩]': { file: 'emoji_27' },
  '[努力]': { file: 'emoji_28' },
  '[抠鼻孔]': { file: 'emoji_29' },
  '[疑问]': { file: 'emoji_30' },
  '[怒骂]': { file: 'emoji_31' },
  '[晕]': { file: 'emoji_32' },
  '[呕吐]': { file: 'emoji_33' },
  '[拜一拜]': { file: 'emoji_160' },
  '[惊喜]': { file: 'emoji_161' },
  '[流汗]': { file: 'emoji_162' },
  '[卖萌]': { file: 'emoji_163' },
  '[默契眨眼]': { file: 'emoji_164' },
  '[烧香拜佛]': { file: 'emoji_165' },
  '[晚安]': { file: 'emoji_166' },
  '[强]': { file: 'emoji_34' },
  '[弱]': { file: 'emoji_35' },
  '[OK]': { file: 'emoji_36' },
  '[拳头]': { file: 'emoji_37' },
  '[胜利]': { file: 'emoji_38' },
  '[鼓掌]': { file: 'emoji_39' },
  '[握手]': { file: 'emoji_167' },
  '[发怒]': { file: 'emoji_40' },
  '[骷髅]': { file: 'emoji_41' },
  '[便便]': { file: 'emoji_42' },
  '[火]': { file: 'emoji_43' },
  '[溜]': { file: 'emoji_44' },
  '[爱心]': { file: 'emoji_45' },
  '[心碎]': { file: 'emoji_46' },
  '[钟情]': { file: 'emoji_47' },
  '[唇]': { file: 'emoji_48' },
  '[戒指]': { file: 'emoji_49' },
  '[钻石]': { file: 'emoji_50' },
  '[太阳]': { file: 'emoji_51' },
  '[有时晴]': { file: 'emoji_52' },
  '[多云]': { file: 'emoji_53' },
  '[雷]': { file: 'emoji_54' },
  '[雨]': { file: 'emoji_55' },
  '[雪花]': { file: 'emoji_56' },
  '[爱人]': { file: 'emoji_57' },
  '[帽子]': { file: 'emoji_58' },
  '[皇冠]': { file: 'emoji_59' },
  '[篮球]': { file: 'emoji_60' },
  '[足球]': { file: 'emoji_61' },
  '[垒球]': { file: 'emoji_62' },
  '[网球]': { file: 'emoji_63' },
  '[台球]': { file: 'emoji_64' },
  '[咖啡]': { file: 'emoji_65' },
  '[啤酒]': { file: 'emoji_66' },
  '[干杯]': { file: 'emoji_67' },
  '[柠檬汁]': { file: 'emoji_68' },
  '[餐具]': { file: 'emoji_69' },
  '[汉堡]': { file: 'emoji_70' },
  '[又鸟腿]': { file: 'emoji_71' },
  '[面条]': { file: 'emoji_72' },
  '[冰淇淋]': { file: 'emoji_73' },
  '[沙冰]': { file: 'emoji_74' },
  '[生日蛋糕]': { file: 'emoji_75' },
  '[蛋糕]': { file: 'emoji_76' },
  '[糖果]': { file: 'emoji_77' },
  '[葡萄]': { file: 'emoji_78' },
  '[西瓜]': { file: 'emoji_79' },
  '[光碟]': { file: 'emoji_80' },
  '[手机]': { file: 'emoji_81' },
  '[电话]': { file: 'emoji_82' },
  '[电视]': { file: 'emoji_83' },
  '[声音开启]': { file: 'emoji_84' },
  '[声音关闭]': { file: 'emoji_85' },
  '[铃铛]': { file: 'emoji_86' },
  '[锁头]': { file: 'emoji_87' },
  '[放大镜]': { file: 'emoji_88' },
  '[灯泡]': { file: 'emoji_89' },
  '[锤头]': { file: 'emoji_90' },
  '[烟]': { file: 'emoji_91' },
  '[炸弹]': { file: 'emoji_92' },
  '[枪]': { file: 'emoji_93' },
  '[刀]': { file: 'emoji_94' },
  '[药]': { file: 'emoji_95' },
  '[打针]': { file: 'emoji_96' },
  '[钱袋]': { file: 'emoji_97' },
  '[钞票]': { file: 'emoji_98' },
  '[银行卡]': { file: 'emoji_99' },
  '[手柄]': { file: 'emoji_100' },
  '[麻将]': { file: 'emoji_101' },
  '[调色板]': { file: 'emoji_102' },
  '[电影]': { file: 'emoji_103' },
  '[麦克风]': { file: 'emoji_104' },
  '[耳机]': { file: 'emoji_105' },
  '[音乐]': { file: 'emoji_106' },
  '[吉他]': { file: 'emoji_107' },
  '[火箭]': { file: 'emoji_108' },
  '[飞机]': { file: 'emoji_109' },
  '[火车]': { file: 'emoji_110' },
  '[公交]': { file: 'emoji_111' },
  '[轿车]': { file: 'emoji_112' },
  '[出租车]': { file: 'emoji_113' },
  '[警车]': { file: 'emoji_114' },
  '[自行车]': { file: 'emoji_115' }
}
